/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/

import { VisionApplication } from '../../application';
import { Measurement } from '../../components/measurement';
import { MotionState } from '../../service/asset';
import { VisionFleetTab } from './fleet';
import { FleetInformationDTO } from './service';
import { IPubSubSubscriber } from '../../pubsub';
import { PublishTopic } from '../../events';

export class FleetTabDiagnostics implements IPubSubSubscriber {
    parent: VisionFleetTab;
    layout!: dhtmlXLayoutObject;
    app: VisionApplication;
    assetGrid!: dhtmlXGridObject;
    toolbar!: dhtmlXToolbarObject;
    selectedGroup = '';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    statusBar: any;
    identifier = '1523ff80-7d3d-4d0e-9d5d-105c4bae837b';

    constructor(parent: VisionFleetTab) {
        VisionApplication.getInstance().pubsub.subscribe(PublishTopic.PM_UPDATED, this);
        this.parent = parent;
        this.app = parent.app;
        this.parent.dataTabbar.addTab('diagnostics', 'Diagnostics', 150, 1, false, false);
        this.layout = this.parent.dataTabbar.cells('diagnostics').attachLayout('1C');

        this.toolbar = this.layout.cells('a').attachToolbar();
        this.layout.cells('a').setText('Diagnostics');
        this.toolbar.setIconsPath('css/imgs/');
        this.toolbar.addButtonSelect('asset_groups', 1, 'Groupings', [], '', '', false, false, 0, '');

        this.assetGrid = this.layout.cells('a').attachGrid();
        this.assetGrid.setHeader('Name,OOS,Odometer,Hours,MIL,DTC Code,Location,Description, Odo Offset(km), Hours Offset', '', [
            'text-align:left;',
            'text-align:center;',
            'text-align:center;',
            'text-align:center;',
            'text-align:center;',
            'text-align:center;',
            'text-align:center;',
            'text-align:center;',
            'text-align:center;',
        ]);
        this.assetGrid.setColSorting('int,int,int,int,str,str,str,int,int');
        this.assetGrid.setColAlign('left,center,center,center,center,center,center,center,center,center');
        this.assetGrid.setColTypes('ro,ch,ed,ed,ro,ro,link,ro,ro,ro');
        this.assetGrid.setColumnIds('name,oos,odometer,hours,mil,dtc_code,location,description,odo_offset,hours_offset');
        this.assetGrid.setImagesPath('css/imgs/');
        this.assetGrid.init();
        this.assetGrid.enableHeaderMenu();

        this.assetGrid.setColumnHidden(this.assetGrid.getColIndexById('odo_offset'), true);
        this.assetGrid.setColumnHidden(this.assetGrid.getColIndexById('hours_offset'), true);

        this.assetGrid.attachEvent('onRowSelect', (_id) => {
            //this.selectAsset(id);
        });
        this.assetGrid.setCustomSorting((a, b, ord, aid, bid) => {
            const aName = this.assetGrid.getUserData(aid, 'name');
            const bName = this.assetGrid.getUserData(bid, 'name');
            return VisionApplication.nameSort(aName, bName, ord);
        }, 0);

        this.app.assetFolderService.folderCache?.forEach((folder) => {
            this.toolbar.addListOption('asset_groups', folder.id, 1, 'button', folder.name, '');
            this.toolbar.clearListOptionImage('asset_groups', folder.id);
        });

        if (localStorage.getItem('selected_folder')) {
            const selectedFolder = localStorage.getItem('selected_folder') as string;
            this.toolbar.setListOptionSelected('asset_groups', selectedFolder);
            const name = this.app.assetFolderService.folderCache?.get(selectedFolder)?.name;
            if (name) {
                this.layout.cells('a').setText('Diagnostics - ' + name);
            }
            this.selectedGroup = selectedFolder;
            this.populateAssetGrid();
        }

        this.toolbar.attachEvent('onClick', (id) => {
            this.selectedGroup = id;
            const name = this.app.assetFolderService.folderCache?.get(id)?.name;
            if (name) {
                this.layout.cells('a').setText('Diagnostics - ' + name);
            }
            this.populateAssetGrid();
            this.updateDiagnostics();
        });

        this.assetGrid.attachEvent('onEditCell', (stage, rId, cId, nValue, _oValue) => {
            const columnId = this.assetGrid.getColumnId(cId);

            if (stage == 2 && columnId == 'odometer') {
                if (nValue == null || nValue == '' || isNaN(Number(nValue)) || Number(nValue) < 0) {
                    dhtmlx.message({
                        type: 'error',
                        text: 'Invalid odometer value. Please enter a valid number.',
                    });
                    return false;
                }
                const newOdometer = this.app.miles2km(nValue);
                this.updateOdo(rId, newOdometer);
            } else if (stage == 2 && columnId == 'hours') {
                if (nValue == null || nValue == '' || isNaN(Number(nValue)) || Number(nValue) < 0) {
                    dhtmlx.message({
                        type: 'error',
                        text: 'Invalid hours value. Please enter a valid number.',
                    });
                    return false;
                }
                this.updateHours(rId, nValue);
            }
            return true;
        });

        this.assetGrid.attachEvent('onCheck', (rId, cInd, state) => {
            const columnId = this.assetGrid.getColumnId(cInd);
            if (columnId == 'oos') {
                const request = this.app.assetService.setOOS(rId, state);

                if (state == true) {
                    this.assetGrid.setRowColor(rId, '#838282');
                } else {
                    this.assetGrid.setRowColor(rId, '#ffffff');
                }
            }
        });

        this.statusBar = this.layout.cells('a').attachStatusBar();
    }

    private populateAssetGrid() {
        this.assetGrid.clearAll(false);
        this.app.assetFolderService.folderCache?.get(this.selectedGroup)?.items.forEach((item) => {
            const assetId = item.id;
            this.assetGrid.addRow(assetId, [item.name, 0, '', '', '', '', '', '', '', ''], 0, '', '', false);
            if (item.name.startsWith('#')) {
                this.assetGrid.setUserData(item.id, 'name', item.name.substring(1));
            } else {
                this.assetGrid.setUserData(item.id, 'name', item.name);
            }
        });
    }

    public onSelect() {
        this.updateDiagnostics();
    }

    public updateDiagnostics() {
        const request = this.parent.service.getInfo();
        request.then((data) => {
            if (data?.ok) {
                if (data.parsedBody) {
                    data.parsedBody?.forEach((info) => {
                        this.updateAsset(info);
                    });
                    this.updateStatusBar();
                } else {
                    this.updateStatusBar();
                }
            }
        });
    }

    private updateAsset(info: FleetInformationDTO) {
        const rowId = info.id as string;
        console.log('Hmm: ' + this.assetGrid.getAllRowIds(','));

        if (rowId && this.assetGrid.getRowIndex(rowId) != -1) {
            this.app.assetService.getAssetMap().then((map) => {
                //const asset = this.app.assetService.assetList.get(info.id);
                const asset = map.get(info.id);

                let odoOffset = 0;
                let hoursOffset = 0;
                if (asset) {
                    hoursOffset = asset.hoursOffset != null ? asset.hoursOffset : 0;
                    odoOffset = asset.odoOffset != null ? asset.odoOffset : 0;
                }

                const oosColumn = this.assetGrid.getColIndexById('oos');
                const odoColumn = this.assetGrid.getColIndexById('odometer');
                const hoursColumn = this.assetGrid.getColIndexById('hours');
                const milColumn = this.assetGrid.getColIndexById('mil');
                const dtcColumn = this.assetGrid.getColIndexById('dtc_code');
                const directionsColumn = this.assetGrid.getColIndexById('location');
                const descriptionColumn = this.assetGrid.getColIndexById('description');
                const odoOffsetColumn = this.assetGrid.getColIndexById('odo_offset');
                const hoursOffsetColumn = this.assetGrid.getColIndexById('hours_offset');

                this.assetGrid.cells(info.id, odoColumn).setValue(String(Measurement.km2miles(info.currentOdometer + odoOffset)));
                this.assetGrid.cells(info.id, hoursColumn).setValue(String((info.currentHours != null ? info.currentHours + hoursOffset : hoursOffset).toFixed(0)));

                if (asset && asset.config.oos == true) {
                    this.assetGrid.cells(info.id, oosColumn).setValue('1');
                    this.assetGrid.setRowColor(info.id, '#838282');
                } else {
                    this.assetGrid.cells(info.id, oosColumn).setValue('0');
                    this.assetGrid.setRowColor(info.id, '#ffffff');
                }

                if (info.errorCodes && info.errorCodes.length > 0) {
                    this.assetGrid.cells(info.id, milColumn).setValue("<img src='icons/fleet-tab.png'>");
                } else {
                    this.assetGrid.cells(info.id, milColumn).setValue('');
                }
                if (info.errorCodes != null) {
                    this.assetGrid.cells(info.id, dtcColumn).setValue(info.errorCodes);
                } else {
                    this.assetGrid.cells(info.id, dtcColumn).setValue('');
                }

                if (info.lastPosition != null) {
                    const paramString = info.lastPosition.coordinates[1] + '%2C' + info.lastPosition.coordinates[0];
                    this.assetGrid.cells(info.id, directionsColumn).setValue('Directions^https://www.google.com/maps/dir/?api=1&destination=' + paramString + '^_blank');
                } else {
                    this.assetGrid.cells(info.id, directionsColumn).setValue('N/A');
                }

                if (asset) {
                    this.assetGrid.cells(info.id, descriptionColumn).setValue(asset.description);
                    this.assetGrid.cells(info.id, odoOffsetColumn).setValue(String(asset.odoOffset));
                    this.assetGrid.cells(info.id, hoursOffsetColumn).setValue(String(asset.hoursOffset));
                } else {
                    this.assetGrid.cells(info.id, descriptionColumn).setValue('');
                    this.assetGrid.cells(info.id, odoOffsetColumn).setValue('');
                    this.assetGrid.cells(info.id, hoursOffsetColumn).setValue('');
                }

                if (info.errorCodes != undefined) {
                    if (info.errorCodes.length > 0) {
                        this.assetGrid.setRowColor(info.id, '#FFA500');
                        this.app.layout.tabbar.cells('FLEET').setText("<img src='icons/fleet-tab-active.png' style='vertical-align:middle; height=20' />&nbsp;&nbsp;&nbsp;FLEET&nbsp;&nbsp;");
                    }
                }
                this.assetGrid.setUserData(info.id, 'motion_state', info.currentState);
            });
        }
    }

    private updateStatusBar() {
        const status = [0, 0, 0, 0, 0, 0, 0];
        this.assetGrid.forEachRow((id) => {
            status[0] += 1;
            switch (this.assetGrid.getUserData(id, 'motion_state')) {
                case MotionState.MOVING:
                    status[1] += 1;
                    break;
                case MotionState.IDLE:
                    status[2] += 1;
                    break;
                case MotionState.STOPPED:
                    status[3] += 1;
                    break;
                case MotionState.OFF:
                    status[4] += 1;
                    break;
                default:
                    status[5] += 1;
                    break;
            }
        });

        const text =
            "<TABLE STYLE='border-spacing: 0px;'><TR>" +
            "<TD STYLE='border: 1px solid black;padding-left: 8px;padding-right: 8px;'><B>Total:</B> " +
            status[0] +
            '</TD>' +
            "<TD STYLE='border: 1px solid black;padding-left: 8px;padding-right: 8px;'><B>Moving:</B> " +
            status[1] +
            '</TD>' +
            "<TD STYLE='border: 1px solid black;padding-left: 8px;padding-right: 8px;'><B>Idle:</B> " +
            status[2] +
            '</TD>' +
            "<TD STYLE='border: 1px solid black;padding-left: 8px;padding-right: 8px;'><B>Stopped:</B> " +
            status[3] +
            '</TD>' +
            "<TD STYLE='border: 1px solid black;padding-left: 8px;padding-right: 8px;'><B>Off:</B> " +
            status[4] +
            '</TD>' +
            "<TD STYLE='border: 1px solid black;padding-left: 8px;padding-right: 8px;'><B>N/A:</B> " +
            status[5] +
            '</TD>' +
            '</TR></TABLE>';

        this.statusBar.setText(text);
    }

    /** Update the asset offset hours.
     *
     * @param assetid
     * @param offset
     */
    private updateHours(assetid: string, offset: string) {
        const request = this.parent.service.setHours(assetid, Number(offset));
        request.then((_data) => {
            const asset = this.app.assetService.assetList.get(assetid);
            if (asset) {
                asset.hoursOffset = Number(offset);
                this.app.assetService.assetList.set(assetid, asset);
            }
            this.app.assetService.setAssetMapDirty();
        });
    }

    /**
     *
     * @param assetid
     * @param offset
     */
    private updateOdo(assetid: string, newOdometerKm: number) {
        const request = this.parent.service.setOdometer(assetid, Number(newOdometerKm));
        request.then((_data) => {
            const asset = this.app.assetService.assetList.get(assetid);
            if (asset) {
                asset.odoOffset = _data.parsedBody?.odometerOffsetKm != null ? _data.parsedBody?.odometerOffsetKm : 0;
                this.app.assetService.assetList.set(assetid, asset);
                this.assetGrid.cells(assetid, 7).setValue(String(asset.odoOffset));
            }
            this.app.assetService.setAssetMapDirty();
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    notify(msg: string, data?: any): void {
        switch (msg) {
            case PublishTopic.PM_UPDATED:
                this.updateDiagnostics();
                break;
        }
    }
}
